import { render, staticRenderFns } from "./category-nofilters.vue?vue&type=template&id=154661f9&"
import script from "./category-nofilters.vue?vue&type=script&lang=js&"
export * from "./category-nofilters.vue?vue&type=script&lang=js&"
import style0 from "./category-nofilters.vue?vue&type=style&index=0&id=154661f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
